import { createSelector } from '@reduxjs/toolkit'

import { getRootBillingState } from 'common/billing/entities/miscellaneous/selectors'
import { AddOnSlug, AddOnStatus } from 'common/billing/interfaces/addOnTypes'
import { ProInfo } from 'common/billing/interfaces/billing'
import { AddOn } from 'shared/api/requests/billing/schemas'

/**
 * Local usage from pro selectors to handle cycle deps.
 */
const getBillingProInfo = (state: RootState): ProInfo => state.billing.pro

export const getAddOnsData = createSelector(
  [getBillingProInfo],
  ({ addons_data }): AddOn[] => addons_data || [],
)

export const getCancelAddOnModalRoot = createSelector(
  [getRootBillingState],
  (billing) => billing.cancelAddOnModal,
)

export const getCancelAddOnModalState = createSelector(
  [getCancelAddOnModalRoot, getAddOnsData],
  (cancelAddOnModal, addOns) => {
    const addOn = addOns.find((addOn) => addOn.slug === cancelAddOnModal.addOnSlug)

    if (cancelAddOnModal.isOpen && addOn) {
      return {
        isOpen: true,
        loading: cancelAddOnModal.loading,
        addOn,
        isInterviewModalOpen: cancelAddOnModal.isInterviewModalOpen,
      } as const
    }

    return {
      isOpen: false,
      loading: cancelAddOnModal.loading,
      addOn: undefined,
      isInterviewModalOpen: cancelAddOnModal.isInterviewModalOpen,
    } as const
  },
)

export const getActiveAddOns = createSelector([getAddOnsData], (addOns): AddOnSlug[] =>
  addOns.reduce<AddOnSlug[]>((slugs, addOn) => {
    if (addOn.status === AddOnStatus.ACTIVE) {
      slugs.push(addOn.slug)
    }
    return slugs
  }, []),
)
